<template>
  <div>
    <SoundSetupRubetek
      v-if="isRubetek"
    />
    <AnalogLineBeward
      v-else
      :doorphone="this.doorphoneEditInfo.doorphone"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SoundSetupRubetek from './components/SoundSetupRubetek';
import AnalogLineBeward from './components/AnalogLineBeward';

export default {
  name: 'SoundSetup',
  components: { SoundSetupRubetek, AnalogLineBeward },
  data: () => {
    return {};
  },
  computed: {
    ...mapGetters({
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
    }),
    isRubetek (item) {
      return item.doorphoneEditInfo.doorphone.manufacturer === 'Rubetek';
    },
  },
};
</script>

<style>

</style>
